export default (options) => {
    const PDFViewerApplicationOptions = window.PDFViewerApplicationOptions
    console.log(PDFViewerApplicationOptions);
    if (PDFViewerApplicationOptions) {
        for (const key in options) {
            PDFViewerApplicationOptions.set(key, options[key])
        }
    }
}